// Do not modify this file, it will be autogenerated
// created on 13.10.2022 13:44:02

export const root = {
  dto: {
    $dtoType: {
      create: 'dto.$dtoType.create',
      read: 'dto.$dtoType.read',
      write: 'dto.$dtoType.write',
      delete: 'dto.$dtoType.delete',
      export: 'dto.$dtoType.export',
      $dtoField: {
        read: 'dto.$dtoType.$dtoField.read',
        write: 'dto.$dtoType.$dtoField.write'
      }
    },
    FileAttachment: {
      upload: 'dto.FileAttachment.upload',
      download: 'dto.FileAttachment.download'
    },
    File: {
      upload: 'dto.File.upload',
      download: 'dto.File.download'
    },
    Order: {
      create: 'dto.Order.create',
      read: 'dto.Order.read',
      write: 'dto.Order.write',
      delete: 'dto.Order.delete'
    }
  },
  Scheduler: {
    openEvSch: 'Scheduler.openEvSch',
    openResSch: 'Scheduler.openResSch',
    order: {
      assign: 'Scheduler.order.assign',
      unassign: 'Scheduler.order.unassign',
      updateInterval: 'Scheduler.order.updateInterval'
    }
  },
  ResourceManager: {
    create: 'ResourceManager.create',
    read: 'ResourceManager.read',
    write: 'ResourceManager.write',
    delete: 'ResourceManager.delete',
    updateInterval: 'ResourceManager.updateInterval'
  },
  Administration: {
    SystemSetting: {
      modify: 'Administration.SystemSetting.modify'
    },
    UserSetting: {
      modify: 'Administration.UserSetting.modify'
    }
  },
  Menuitems: {
    dashboard: 'Menuitems.dashboard',
    einsatzplanung: 'Menuitems.einsatzplanung',
    rechnungen: 'Menuitems.rechnungen',
    stammdaten: {
      show: 'Menuitems.stammdaten.show',
      produkte: 'Menuitems.stammdaten.produkte',
      produkttemplates: 'Menuitems.stammdaten.produkttemplates',
      organisations: 'Menuitems.stammdaten.organisations',
      persons: 'Menuitems.stammdaten.persons'
    },
    vertrieb: {
      show: 'Menuitems.vertrieb.show',
      angebote: 'Menuitems.vertrieb.angebote',
      auftraege: 'Menuitems.vertrieb.auftraege'
    },
    ressourcenverwaltung: {
      show: 'Menuitems.ressourcenverwaltung.show',
      ressourcen: 'Menuitems.ressourcenverwaltung.ressourcen',
      anwesenheiten: 'Menuitems.ressourcenverwaltung.anwesenheiten'
    },
    administration: {
      show: 'Menuitems.administration.show',
      benutzer: 'Menuitems.administration.benutzer',
      rollenverwaltung: 'Menuitems.administration.rollenverwaltung',
      rechteverwaltung: 'Menuitems.administration.rechteverwaltung',
      katalogverwaltung: 'Menuitems.administration.katalogverwaltung',
      dtoKonfiguration: 'Menuitems.administration.dtoKonfiguration',
      einstellungen: 'Menuitems.administration.einstellungen'
    },
    configuration: {
      show: 'Menuitems.configuration.show',
      objekte: 'Menuitems.configuration.objekte',
      katalogverwaltung: 'Menuitems.configuration.katalogverwaltung',
      dtoKonfiguration: 'Menuitems.configuration.dtoKonfiguration',
      actions: 'Menuitems.configuration.actions',
      einstellungen: 'Menuitems.configuration.einstellungen'
    }
  }
}

export const list = [
  'dto.$dtoType.create',
  'dto.$dtoType.read',
  'dto.$dtoType.write',
  'dto.$dtoType.delete',
  'dto.$dtoType.export',
  'dto.$dtoType.$dtoField.read',
  'dto.$dtoType.$dtoField.write',
  'dto.FileAttachment.upload',
  'dto.FileAttachment.download',
  'dto.File.upload',
  'dto.File.download',
  'dto.Order.create',
  'dto.Order.read',
  'dto.Order.write',
  'dto.Order.delete',
  'Scheduler.openEvSch',
  'Scheduler.openResSch',
  'Scheduler.order.assign',
  'Scheduler.order.unassign',
  'Scheduler.order.updateInterval',
  'ResourceManager.create',
  'ResourceManager.read',
  'ResourceManager.write',
  'ResourceManager.delete',
  'ResourceManager.updateInterval',
  'Administration.SystemSetting.modify',
  'Administration.UserSetting.modify',
  'Menuitems.dashboard',
  'Menuitems.einsatzplanung',
  'Menuitems.rechnungen',
  'Menuitems.stammdaten.show',
  'Menuitems.stammdaten.produkte',
  'Menuitems.stammdaten.produkttemplates',
  'Menuitems.stammdaten.organisations',
  'Menuitems.stammdaten.persons',
  'Menuitems.vertrieb.show',
  'Menuitems.vertrieb.angebote',
  'Menuitems.vertrieb.auftraege',
  'Menuitems.ressourcenverwaltung.show',
  'Menuitems.ressourcenverwaltung.ressourcen',
  'Menuitems.ressourcenverwaltung.anwesenheiten',
  'Menuitems.administration.show',
  'Menuitems.administration.benutzer',
  'Menuitems.administration.rollenverwaltung',
  'Menuitems.administration.rechteverwaltung',
  'Menuitems.administration.katalogverwaltung',
  'Menuitems.administration.dtoKonfiguration',
  'Menuitems.administration.einstellungen',
  'Menuitems.configuration.show',
  'Menuitems.configuration.objekte',
  'Menuitems.configuration.katalogverwaltung',
  'Menuitems.configuration.dtoKonfiguration',
  'Menuitems.configuration.actions',
  'Menuitems.configuration.einstellungen'
]
